module.exports = __webpack_public_path__ + "static/media/food.80ba8817.svg";